export default "__VITE_ASSET__BM5wfs2W__"